import { BadgeCheck } from "lucide-react";
import { parentBrand } from "@/lib/deployments";

/**
 * Compact "SAM.gov · Active Registration" credibility badge.
 * Two variants:
 *   - default (dark backgrounds): gold accent, ivory text
 *   - light (cream backgrounds):  navy text, gold check
 */
export default function SamGovBadge({ variant = "default", className = "", "data-testid": testId = "sam-gov-badge" }) {
  if (!parentBrand.samRegistered) return null;

  const isLight = variant === "light";
  const wrapCls = isLight
    ? "border-[#1F2937] text-[#1F2937] bg-white/70"
    : "border-[#D4AF37]/60 text-[#F9F7F1] bg-[#0A192F]/60";
  const checkCls = isLight ? "text-[#B8860B]" : "text-[#D4AF37]";
  const subCls = isLight ? "text-[#6B7280]" : "text-[#94A3B8]";

  return (
    <div
      data-testid={testId}
      className={`inline-flex items-center gap-2.5 border ${wrapCls} px-3 py-1.5 ${className}`}
    >
      <BadgeCheck className={`h-4 w-4 ${checkCls} shrink-0`} />
      <div className="leading-tight">
        <div className="font-mono text-[10px] uppercase tracking-[0.22em]">
          SAM.gov · Active Registration
        </div>
        <div className={`font-mono text-[9px] uppercase tracking-[0.18em] ${subCls}`}>
          {parentBrand.consultancy} · CAGE {parentBrand.cageCode} · {parentBrand.samRegistrationScope}
        </div>
      </div>
    </div>
  );
}
